const MaxNameLength = 80;
export const nameSliceHandler = (fileName: string) => {
  if (typeof fileName !== "string") return;
  const nameIndex = fileName.lastIndexOf(".");
  if (nameIndex < 0) return fileName;
  const extension = fileName.slice(nameIndex);
  const nameWithoutExtension = fileName.slice(0, nameIndex);
  const truncatedName = nameWithoutExtension.slice(0, MaxNameLength);
  return `${truncatedName}${extension}`;
};
